export const DEFAULT_PLACEHOLDER_PIC =
  'data:image/png;base64,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';

export const DEFAULT_BREAKPOINTS = {
  '300': {
    slidesPerView: 2,
  },
  '360': {
    slidesPerView: 3,
  },
  '540': {
    slidesPerView: 4,
  },
  '768': {
    slidesPerView: 6,
  },
  '912': {
    slidesPerView: 7,
  },
  '1024': {
    slidesPerView: 8,
  },
  '1220': {
    slidesPerView: 10,
  },
};

export const DEFAULT_BREAKPOINTS_SELECCION = {
  '300': {
    slidesPerView: 2.5,
  },
  '360': {
    slidesPerView: 3,
  },
  '425': {
    slidesPerView: 3.5,
  },
  '540': {
    slidesPerView: 4,
  },
  '768': {
    slidesPerView: 7.5,
  },
  '912': {
    slidesPerView: 8,
  },
  '1024': {
    slidesPerView: 8,
  },
  '1220': {
    slidesPerView: 12,
  },
  '1900': {
    slidesPerView: 12,
  },
  '2500': {
    slidesPerView: 13,
  },
  '2900': {
    slidesPerView: 14,
  },
  '4000': {
    slidesPerView: 24,
  },
};

export const DEFAULT_BREAKPOINTS_HOME = {
  '300': {
    slidesPerView: 1.22,
  },
  '340': {
    slidesPerView: 1.4,
  },
  '370': {
    slidesPerView: 1.43,
  },
  '400': {
    slidesPerView: 1.635,
  },
  '450': {
    slidesPerView: 1.77,
  },
  '500': {
    slidesPerView: 2,
  },
  '540': {
    slidesPerView: 1.33,
  },
  '585': {
    slidesPerView: 1.43,
  },
  '630': {
    slidesPerView: 1.5,
  },
  '680': {
    slidesPerView: 1.7,
  },
  '720': {
    slidesPerView: 1.8,
  },
  '768': {
    slidesPerView: 1.8,
  },
  '810': {
    slidesPerView: 1.9,
  },
  '860': {
    slidesPerView: 2.05,
  },
  '905': {
    slidesPerView: 2.2,
  },
  '955': {
    slidesPerView: 2.3,
  },
  '1024': {
    slidesPerView: 2.4,
  },
  '1100': {
    slidesPerView: 2.6,
  },
  '1220': {
    slidesPerView: 3.1,
  },
  '1330': {
    slidesPerView: 3.37,
  },
  '1500': {
    slidesPerView: 3.5,
  },
  '1700': {
    slidesPerView: 3.9,
  },
  '1900': {
    slidesPerView: 4.35,
  },
  '2100': {
    slidesPerView: 4.9,
  },
  '2300': {
    slidesPerView: 5.4,
  },
  '2500': {
    slidesPerView: 6,
  },
  '2800': {
    slidesPerView: 6.5,
  },
  '3000': {
    slidesPerView: 7.2,
  },
  '3500': {
    slidesPerView: 8.2,
  },
  '4000': {
    slidesPerView: 9,
  },
  '4400': {
    slidesPerView: 10,
  },
  '4800': {
    slidesPerView: 11,
  },
  '5200': {
    slidesPerView: 12,
  },
  '5600': {
    slidesPerView: 13,
  },
  '6000': {
    slidesPerView: 14,
  },
};

export const DEFAULT_BREAKPOINTS_RESULTADOS = {
  '300': {
    slidesPerView: 1.3,
  },
  '340': {
    slidesPerView: 1.4,
  },
  '370': {
    slidesPerView: 1.5,
  },
  '400': {
    slidesPerView: 1.635,
  },
  '450': {
    slidesPerView: 1.77,
  },
  '500': {
    slidesPerView: 2,
  },
  '540': {
    slidesPerView: 1.33,
  },
  '585': {
    slidesPerView: 1.43,
  },
  '630': {
    slidesPerView: 1.5,
  },
  '680': {
    slidesPerView: 1.7,
  },
  '720': {
    slidesPerView: 1.8,
  },
  '768': {
    slidesPerView: 1.88,
  },
  '810': {
    slidesPerView: 1.9,
  },
  '860': {
    slidesPerView: 2.05,
  },
  '905': {
    slidesPerView: 2.2,
  },
  '955': {
    slidesPerView: 2.3,
  },
  '1024': {
    slidesPerView: 2.5,
  },
  '1100': {
    slidesPerView: 7,
  },
  '1220': {
    slidesPerView: 7,
  },
  '1330': {
    slidesPerView: 7,
  },
  '1500': {
    slidesPerView: 7,
  },
  '1700': {
    slidesPerView: 3.9,
  },
  '1900': {
    slidesPerView: 4.35,
  },
  '2100': {
    slidesPerView: 4.9,
  },
  '2300': {
    slidesPerView: 5.4,
  },
  '2500': {
    slidesPerView: 6,
  },
  '2800': {
    slidesPerView: 6.5,
  },
  '3000': {
    slidesPerView: 7.2,
  },
  '3500': {
    slidesPerView: 8.2,
  },
  '4000': {
    slidesPerView: 9,
  },
  '4400': {
    slidesPerView: 10,
  },
  '4800': {
    slidesPerView: 11,
  },
  '5200': {
    slidesPerView: 12,
  },
  '5600': {
    slidesPerView: 13,
  },
  '6000': {
    slidesPerView: 14,
  },
};

export const BREAKPOINTS_SEARCHER = {
  '300': {
    slidesPerView: 2,
  },
  '360': {
    slidesPerView: 3,
  },
  '540': {
    slidesPerView: 4,
  },
  '768': {
    slidesPerView: 4,
  },
  '912': {
    slidesPerView: 6,
  },
  '1024': {
    slidesPerView: 6,
  },
  '1220': {
    slidesPerView: 8,
  },
  '1632': {
    slidesPerView: 10.75,
  },
  '1912': {
    slidesPerView: 12.9,
  },
  '2192': {
    slidesPerView: 15.3,
  },
  '2472': {
    slidesPerView: 17.4
  },
  '2752':{
    slidesPerView:19,
  }
};
